// OwnersTab.tsx
import React from "react";
import { OwnerEarnings, ColorTheme } from "../types/revenue.types";
import { OwnerEarningsCard } from "../cards/OwnerEarningsCard";
import RevenueService from "../../../services/revenueService";

interface OwnersTabProps {
  ownerEarnings: OwnerEarnings[];
  colorTheme: ColorTheme;
}

export const OwnersTab: React.FC<OwnersTabProps> = ({
  ownerEarnings,
  colorTheme,
}) => {
  const totalEarnings = ownerEarnings.reduce(
    (sum, o) => sum + o.total_earned,
    0,
  );

  return (
    <div>
      {/* Summary Header */}
      <div
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: colorTheme.gray900,
                marginBottom: "4px",
              }}
            >
              👑 Sponsor Earnings
            </h2>
            <p style={{ fontSize: "14px", color: colorTheme.gray600 }}>
              {ownerEarnings.length} equipment sponsors
            </p>
          </div>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: colorTheme.warning,
            }}
          >
            {RevenueService.formatCurrency(totalEarnings)}
          </div>
        </div>
      </div>

      {/* Owner Cards */}
      {ownerEarnings.map((owner) => (
        <OwnerEarningsCard
          key={owner.owner_id}
          owner={owner}
          colorTheme={colorTheme}
        />
      ))}

      {ownerEarnings.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: colorTheme.gray500,
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>👑</div>
          <p>No equipment sponsor earnings found for the selected period.</p>
          <p style={{ fontSize: "14px" }}>
            Sponsor earnings will appear when services using their equipment are
            completed.
          </p>
        </div>
      )}
    </div>
  );
};
